export { default as Banner } from './Banner'
export { default as PreSales } from './PreSales'
export { default as AfterSales } from './AfterSales'
export { default as CallHighlights } from './CallHighlights'
export { default as CareTeam } from './CareTeam'
export { default as Warranty } from './Warranty'
export { default as AppDownload } from './AppDownload'
export { default as Recommendation } from './Recommendation'
export { default as Subheader } from './Subheader'
